import { render, staticRenderFns } from "./ReservationTimer.vue?vue&type=template&id=68ae7a38&"
import script from "./ReservationTimer.vue?vue&type=script&lang=js&"
export * from "./ReservationTimer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports